import React from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';
import { getOfficeBrandName } from '../../shared/utils/officeBranding';
import { buildOfficeSchedulingUrl } from '../../shared/utils/urls';
import WidgetHeader from './WidgetHeader';

interface WidgetProviderHeaderProps {
  provider: {
    id: string;
    display: string;
    office: {
      id: string;
      display: string;
      messagingName: string;
      group: {
        id: string;
        name: string;
      } | null;
      practice: {
        display: string;
      };
    };
    profile: {
      id: string;
      photo: string;
      photo2x: string;
    };
  };
}

export default function WidgetProviderHeader({ provider }: WidgetProviderHeaderProps) {
  const intl = useIntl();
  const location = useLocation();
  const { profile, office } = provider;
  return (
    <WidgetHeader
      title={provider.display}
      subtitle={getOfficeBrandName(provider.office)}
      photo={profile.photo}
      photo2x={profile.photo2x}
      changeUrl={buildOfficeSchedulingUrl(office.id, { location })}
      changeText={intl.formatMessage({
        id: 'widgets.WidgetProviderHeader.changeText',
        defaultMessage: 'Change Provider',
      })}
      showBackButton
    />
  );
}
